
export class StockQuantityBatchModel {
  public static IRI = '/api/stock_quantity_batches';
  public material: string;
  public amount: string;
  public barcode: string;
}
